import hyperdom from 'hyperdom'
import BasePaymentMethod from './basePaymentMethod.jsx'
import * as validation from '../../../../validation.js'

export default class Reference extends BasePaymentMethod {
  constructor (payment) {
    super(payment)
    this.schema = this.payment.schemas.paymentReference
    this.data = {}
  }

  validate (results) {
    validation.validate(this.data, this.schema, results)
  }

  render () {
    return <div class='o-accent-box'>
      { this.payment.renderPaymentMethodSelection() }
      <div class='payment-details'>
        <h2 class='u-margin-top-medium'>{this.displayName}<span class='field-required'>*</span></h2>

        <div class='o-form-item form-item-payment-reference'>
          <label for='reference' class='u-visually-hidden'>Reference</label>

          <input id='reference' type='text' class='o-form-item__txt-input' placeholder='Enter reference number *'
            binding={[this.data, 'reference']}
            onblur={() => this.payment.fieldVisited(this.data, 'reference')}
            name='reference' />

          { this.payment.renderValidationError(this.data, 'reference') }
        </div>
      </div>
    </div>
  }
}

